import React, { Component } from 'react';
import AccountMenu from '../Modules/AccountMenu'
import MijnCrData from '../Modules/MijnCR'

class MijnCR extends Component {

    render() {
        return (
            <div className="route account">
            {
                /*
                    TODO: WHOLE NEW MIJN-CR PAGE
                */
            }
                <AccountMenu />
                <div className="grey-bg">
                    <h1 className="pageTitle">
                        Mijn CR
                    </h1>
                    <MijnCrData />
                </div>
                
            </div>
        );
    }
}

export default MijnCR;


// WEBPACK FOOTER //
// ./src/components/Member/Pages/MijnCR.js